<script lang="ts">
  let {
    checked = $bindable(false),
    label,
    ariaLabel,
    onchange,
  }: {
    checked?: boolean;
    label?: string;
    /** Nombre solo para lectores de pantalla, cuando el texto visible ya está al lado. */
    ariaLabel?: string;
    onchange?: (value: boolean) => void;
  } = $props();
</script>

<!-- El interruptor del sistema: `choice` ordena etiqueta y control, y
     `switch` pinta la pista con su perilla (components.css). -->
<label class="switch-control choice switch">
  <input
    type="checkbox"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel ?? label}
    bind:checked
    onchange={(e) => onchange?.(e.currentTarget.checked)}
  />
  {#if label}
    <span class="switch-label">{label}</span>
  {/if}
</label>

<style>
  /* El estirado de la perilla al pulsar vive en el catálogo (`.switch input`),
     no aquí: lo llevan todos los interruptores, también los que se escriben a
     mano y los de las páginas publicadas. */
  .switch-control {
    cursor: pointer;
  }
</style>
